module.exports = __webpack_public_path__ + "img/wz-8-1-3.c6a757de.jpg";